import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faTrash,
  faEdit,
  faTimes,
  faChevronLeft,
  faChevronRight,
  faBars,
  faGauge,
  faChartLine,
  faLandmark,
  faHandHoldingDollar,
  faFileInvoice,
  faFileInvoiceDollar,
  faMoneyBillTransfer,
  faFileContract,
  faScaleBalanced,
  faAddressBook,
  faCube,
  faTruck,
  faTruckField,
  faBoxesStacked,
  faGears,
  faWarehouse,
  faClipboardCheck,
  faTags,
  faCoins,
  faFlask,
  faUserShield,
  faCartShopping,
  faBox,
  faIndustry,
  faUsers,
  faUserClock,
  faTrashCan,
  faPrint,
  faCircleCheck,
  faCircleExclamation,
  faTriangleExclamation,
  faCircleInfo,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFile,
  faUpload,
  faRightFromBracket,
  faCalendarDays,
  faHistory,
  faDownload,
  faMinus,
  faPlus,
  faPencilAlt,
  faTimesCircle,
  faList, // 新增 faList 圖標
  faSearch, // 新增 faSearch 圖標
  faBullhorn, // 新增 faBullhorn 圖標（營銷儀表板）
  // 選單（config/modules.js、generateMenu、側欄箭頭）用到但先前未註冊、顯示為空白的圖示
  faAngleDown,
  faAngleRight,
  faBuilding,
  faChartPie,
  faCogs,
  faDollarSign,
  faGlobe,
  faHardHat,
  faLeaf,
  faMedkit,
  faReceipt,
  faShoppingCart,
  faWaveSquare,
  faYenSign,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faTrash, faEdit, faTimes, faChevronLeft, faChevronRight, faBars, faGauge,
  faChartLine, faLandmark, faHandHoldingDollar, faFileInvoice, faFileInvoiceDollar,
  faMoneyBillTransfer, faFileContract, faScaleBalanced, faAddressBook, faCube,
  faTruck, faTruckField, faBoxesStacked, faGears, faWarehouse, faClipboardCheck,
  faTags, faCoins, faFlask, faUserShield, faUserClock, faCartShopping, faBox, faIndustry,
  faUsers, faTrashCan, faPrint, faCircleCheck, faCircleExclamation,
  faTriangleExclamation, faCircleInfo, faFilePdf, faFileWord, faFileExcel,
  faFileImage, faFile, faUpload, faRightFromBracket, faCalendarDays,
  faHistory,
  faDownload,
  faMinus,
  faPlus,
  faPencilAlt,
  faTimesCircle,
  faList, // 新增 faList 圖標
  faSearch, // 新增 faSearch 圖標
  faBullhorn, // 新增 faBullhorn 圖標（營銷儀表板）
  faAngleDown, faAngleRight, faBuilding, faChartPie, faCogs, faDollarSign, faGlobe, faHardHat, faLeaf, faMedkit, faReceipt, faShoppingCart, faWaveSquare, faYenSign, faPaperPlane
)

export default FontAwesomeIcon
